import { createContext } from 'react';
const StatusContext = createContext();
export default StatusContext;
